import React from 'react';
import { PieChart } from 'react-minimal-pie-chart';
import { ProgressChartProps } from '../../types';
import styles from './ProgressChart.module.scss';

export const ProgressChart: React.FC<ProgressChartProps> = ({ completed, total, size = 109 }) => {
  const percentage = total > 0 ? (completed / total) * 100 : 0;

  const data = [
    {
      title: 'Completed',
      value: completed,
      color: '#748FFC',
    },
    {
      title: 'Remaining',
      value: total - completed,
      color: '#868e961a'
    },
  ];

  return (
    <div className={styles['progress-chart']} style={{ width: size, height: size }}>
      <div className={styles['progress-chart__container']}>
        <PieChart
          data={data}
          lineWidth={20}
          startAngle={-90}
          lengthAngle={360}
          animate={true}
          animationDuration={500}
          className={styles['progress-chart__pie']}
          aria-label={`Progress: ${completed} out of ${total} days completed`}
        />
        <div className={styles['progress-chart__label']}>
          <span className={styles['progress-chart__text']}>
            {completed}/{total}
          </span>
        </div>
      </div>
    </div>
  );
};
